// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	//site.svg.init();
	site.nav.init();
	site.responsive.tables();
	site.responsive.videos();
	site.divisionPicker.init();
	site.tables.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	$accordions = $('section.accordion');
	$accordions.each(function (i) {
		var $this = $(this);
		const $accord = $this.closest('.accordion');
		let id = 'accord_div' + i;
		const $button = $('<input value="Prenta innihald gardínu" class="no-print print__button" id="" type="button" style="display: block;">');
		$button.attr('id', id);
		$this.find('.wrap').append($button);
		$button.click({$accord}, printDiv);
	});

	function printDiv(event) {
		const divToPrint= event.currentTarget.parentElement.parentElement;

		const newWin = window.open('','Print-Window');

		newWin.document.open();
		newWin.document.write('<html><head><title></title>');
		newWin.document.write('<link rel="stylesheet" href="/static/themes/2020/theme.css" media="all" type="text/css" />');
		newWin.document.write('</head><body >');
		newWin.document.write(divToPrint.innerHTML);
		newWin.document.write('</body></html>');

		newWin.document.close();
		newWin.focus(); // IE 10

		setTimeout(() => {
			newWin.print();
			newWin.close();
		}, 100);
	}
});
